module.exports = __webpack_public_path__ + "img/octoih-1720-pagina-de-titlu-big.e55ab01e.jpg";